import React, { Component } from 'react';
import VerifyResend from './VerifyResend';
import axios from 'axios';
import PropTypes from 'prop-types';
import ErrorHandler from '../errorHandler/errorHandler';
import { setupOtpBeforeUnload, teardownOtpBeforeUnload } from './otpBeforeUnload';

const propTypes = {
    errorMessage: PropTypes.string,
    destinationText: PropTypes.string.isRequired,
    deliveryMethod: PropTypes.string.isRequired,
    editURL: PropTypes.string.isRequired,
    deviceFieldName: PropTypes.string,
    phoneNumberDigits: PropTypes.number,
    resendUrl: PropTypes.string
};

class VerifyMfaUserOTPContainer extends Component {
    constructor(props) {
        super(props);
        const { errorMessage, destinationText, deliveryMethod } = props;
        var typeString = deliveryMethod === 'sms' ? 'text message' : 'voice call';

        this.state = {
            message: 'A ' + typeString + ' with a verification code has been sent to:',
            inputValue: '',
            showEdit: false,
            error: errorMessage !== undefined ? errorMessage : '',
            shownPhoneNumber: destinationText.slice(-2),
            showOptions: deliveryMethod === 'sms' || deliveryMethod === 'voice'
        };

        this.resendOTP = this.resendOTP.bind(this);
        this.handleInput = this.handleInput.bind(this);
    }

    handleInput(event) {
        this.setState({ inputValue: event.target.value });
    }

    componentDidMount() {
        setupOtpBeforeUnload(this.props.deliveryMethod, { inputName: 'Code' });
    }

    componentWillUnmount() {
        teardownOtpBeforeUnload();
    }

    resendOTP(event) {
        const { deviceFieldName, deliveryMethod, resendUrl } = this.props;

        event.preventDefault();
        this.setState({
            message: 'Sending another verification code to:',
            error: ''
        });
        var deviceCodes = { 0: 'Phone1', 1: 'Phone2' };
        var selectedPhoneNumber = deviceCodes[deviceFieldName];
        var params = {
            SelectedPhoneNumber: selectedPhoneNumber,
            DeliveryMethod: deliveryMethod
        };

        axios
            .post(resendUrl, params)
            .then(response => {
                if (response.data.success !== null && response.data.success) {
                    var typeString = this.props.deliveryMethod === 'email' ? 'email' : 'phone';
                    this.setState({
                        message:
                            'Another verification code has been sent to your ' + typeString + '.'
                    });
                } else if (response.data.maxReached !== null && response.data.maxReached) {
                    // If baseURI is implemented, use correct relative path. For IE, special case.
                    window.location.href = document.baseURI ? './Help/Index' : '../Help/Index';
                } else {
                    this.setState({
                        message: '',
                        error: 'Resending the verification code was not successful. Please try again.'
                    });
                }
            })
            .catch(function (error) {
                new ErrorHandler().logError(error);
            });
    }
    render() {
        let maskedNumbers;
        if (this.props.phoneNumberDigits === 12) {
            maskedNumbers = (
                <span className="mfa-info-edit-text">
                    &#9679;&#9679;-&#9679;&#9679;&#9679;-&#9679;&#9679;&#9679;-&#9679;&#9679;
                    {this.state.shownPhoneNumber}
                </span>
            );
        } else if (this.props.phoneNumberDigits === 11) {
            maskedNumbers = (
                <span className="mfa-info-edit-text">
                    &#9679;-&#9679;&#9679;&#9679;-&#9679;&#9679;&#9679;-&#9679;&#9679;
                    {this.state.shownPhoneNumber}
                </span>
            );
        } else {
            maskedNumbers = (
                <span className="mfa-info-edit-text">
                    &#9679;&#9679;&#9679;-&#9679;&#9679;&#9679;-&#9679;&#9679;
                    {this.state.shownPhoneNumber}
                </span>
            );
        }
        return (
            <div>
                <p>{this.state.message}</p>
                <div className="mfa-info-edit">{maskedNumbers}</div>

                <VerifyResend
                    handleResend={this.resendOTP}
                    showOptions={this.state.showOptions}
                    resendUrl={this.props.editURL}
                />
                <div className="asc-form-group asc-form-group--small mfa-form-group--nobottommargin">
                    <label className="asc-form-label" htmlFor="Code">
                        Verification Code
                    </label>
                </div>
                <p>Please allow a couple minutes for delivery.</p>
                <div className="asc-form-group--small text--left">
                    <input
                        className="asc-form-input asc-form-input--small"
                        type="text"
                        name="Code"
                        value={this.state.inputValue}
                        onChange={this.handleInput}
                        pattern="\d*"
                        required
                    />
                </div>

                {typeof this.state.error !== 'undefined' && (
                    <div className="is-warning">
                        <p className="asc-form-help">{this.state.error}</p>
                    </div>
                )}
            </div>
        );
    }
}

VerifyMfaUserOTPContainer.propTypes = propTypes;
export default VerifyMfaUserOTPContainer;
